import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LatestDeviceDiagnosticDto } from '@rocksoft/appmanagement-sdk';
import { ErrorModel } from '@rocksoft/shared';

export const LatestDeviceDiagnosticsActions = createActionGroup({
  source: 'Latest Device Diagnostics',
  events: {
    'Latest device diagnostics requested': props<{ udids: string[] }>(),
    'Latest device diagnostics cleared': emptyProps(),
  },
});

export const LatestDeviceDiagnosticsApiActions = createActionGroup({
  source: 'Latest Device Diagnostics API',
  events: {
    'Latest device diagnostics loaded': props<{ diagnostics: LatestDeviceDiagnosticDto[] }>(),
    'Latest device diagnostics loaded error': props<{ error: ErrorModel }>(),
  },
});

export const LatestDeviceDiagnosticsSignalRActions = createActionGroup({
  source: 'Latest Device Diagnostics SignalR',
  events: {
    'Latest device diagnostic updated': props<{ diagnostic: LatestDeviceDiagnosticDto }>(),
  },
});
